var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { faExclamationCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Stack } from "syf-component-library/ui/spacing";
import analyticsHandler from "./helpers";
import { StatementsCaption, StatementsTableContainer, StatementsTableHeader, StatementsTableRow, WideDataCell, } from "./subcomponents";
import { PAGE_NAME } from "../../../const/analytics";
import { useAccountSummary, useStatementsEnrollment, } from "../../../const/syfApiQueries";
import { useStatementsContext } from "../../../context/statementsContext";
import formatMonthDayYearDate from "../../../helpers/formatMonthDayYearDate";
import triggerAnalytics from "../../../helpers/triggerAnalytics";
import MessageBox from "../../atoms/MessageBox";
import { colors } from "../../theme";
import NoStatementsSection from "../NoStatementsSection";
import PDFButton from "../PdfButton";
import PrivacyPolicyLink from "../PrivacyPolicyLink";
var StatementsTable = function (_a) {
    var _b;
    var statementsList = _a.statementsList, isNoRecentStatements = _a.isNoRecentStatements;
    var t = useTranslation().t;
    var accountId = useStatementsContext().state.accountId;
    var _c = useState(false), isFetchingAnyPdf = _c[0], setIsFetchingAnyPdf = _c[1];
    var _d = useState(true), isPopUpBlockerOpen = _d[0], setIsPopUpBlockerOpen = _d[1];
    var closePopUpBlockerHandler = function () {
        setIsPopUpBlockerOpen(false);
    };
    var accountSummary = useAccountSummary(accountId).data;
    var enrollmentStatusData = useStatementsEnrollment(accountId).data;
    var updateIsFetchingAnyPdf = function (status) {
        setIsFetchingAnyPdf(status);
    };
    useEffect(function () {
        var _a, _b;
        analyticsHandler((_b = (_a = accountSummary === null || accountSummary === void 0 ? void 0 : accountSummary.product) === null || _a === void 0 ? void 0 : _a.clientId) !== null && _b !== void 0 ? _b : "", enrollmentStatusData === null || enrollmentStatusData === void 0 ? void 0 : enrollmentStatusData.enrollmentType);
    }, [(_b = accountSummary === null || accountSummary === void 0 ? void 0 : accountSummary.product) === null || _b === void 0 ? void 0 : _b.clientId, enrollmentStatusData]);
    useEffect(function () {
        var _a;
        if (isPopUpBlockerOpen) {
            triggerAnalytics({
                pageName: PAGE_NAME.VIEW,
                errorMessage: t("modal.popUpBlockerTitle", { lng: "en" }),
                message: t("modal.popUpBlockerDescription", { lng: "en" }),
                messageType: "pop-up error",
                clientName: (_a = accountSummary === null || accountSummary === void 0 ? void 0 : accountSummary.product) === null || _a === void 0 ? void 0 : _a.clientId,
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isPopUpBlockerOpen]);
    if (statementsList.length === 0) {
        return _jsx(NoStatementsSection, { isNoRecentStatements: isNoRecentStatements });
    }
    var isInsertAvailable = statementsList.some(function (statement) {
        var _a, _b;
        return ((_a = statement.statementDetails) === null || _a === void 0 ? void 0 : _a.statementInsert) !== undefined &&
            ((_b = statement.statementDetails) === null || _b === void 0 ? void 0 : _b.statementInsert) !== null;
    });
    return (_jsxs(_Fragment, { children: [isPopUpBlockerOpen && (_jsx(MessageBox, { type: "info", color: colors.babyBlue, icon: _jsx(FontAwesomeIcon, { icon: faExclamationCircle, fontSize: "24px" }), title: "modal.popUpBlockerTitle", description: "modal.popUpBlockerDescription", closeHandler: closePopUpBlockerHandler })), _jsx(Stack, { size: "base" }), _jsxs(StatementsTableContainer, { children: [_jsx(StatementsCaption, { children: t("modal.table.caption") }), _jsx(StatementsTableHeader, { children: _jsxs("tr", { children: [_jsx("th", __assign({ scope: "col" }, { children: t("modal.table.date") })), _jsx("th", __assign({ scope: "col" }, { children: t("modal.table.balance") }))] }) }), _jsx("tbody", __assign({ "data-cy": "statementsTableBody" }, { children: statementsList.map(function (data) {
                            var _a, _b, _c, _d;
                            return (_jsxs(StatementsTableRow, __assign({ tableDate: t("modal.table.date"), tableBalance: t("modal.table.balance") }, { children: [_jsx("td", { children: formatMonthDayYearDate(data.statementDate) }), _jsxs("td", { children: ["$", (_a = data.statementDetails) === null || _a === void 0 ? void 0 : _a.statementAmount] }), ((_b = data.statementDetails) === null || _b === void 0 ? void 0 : _b.ebillAvailable) && (_jsx(WideDataCell, __assign({ isInsertAvailable: isInsertAvailable }, { children: _jsx(PDFButton, { statementsData: data, updateIsFetchingAnyPdf: updateIsFetchingAnyPdf, isFetchingAnyPdf: isFetchingAnyPdf, pdfType: "statement" }) }))), ((_c = data.statementDetails) === null || _c === void 0 ? void 0 : _c.statementInsert) && (_jsx(WideDataCell, __assign({ isInsertAvailable: isInsertAvailable }, { children: _jsx(PDFButton, { statementsData: data, updateIsFetchingAnyPdf: updateIsFetchingAnyPdf, isFetchingAnyPdf: isFetchingAnyPdf, pdfType: "insert" }) }))), !((_d = data.statementDetails) === null || _d === void 0 ? void 0 : _d.statementInsert) &&
                                        isInsertAvailable && _jsx("td", {})] }), data.statementDate));
                        }) }))] }), _jsx(PrivacyPolicyLink, { accountId: accountId })] }));
};
export default StatementsTable;
